import React from "react";

/*
    Section Title
*/
export class SectionTitle extends React.Component {
  /*constructor( props ){

    }*/
  render() {
    let title = null;
    if (typeof this.props.color !== "undefined") {
      title = (
        <h3
          className={`sectionTitle dash-below dash-center dash-medium dash-${
            this.props.color
          } uppercase ${this.props.classes}`}
        >
          {this.props.children}
        </h3>
      );
    } else {
      title = (
        <h3 className={`sectionTitle uppercase ${this.props.classes}`}>
          {this.props.children}
        </h3>
      );
    }

    return title;
  }
}

/*
    CardTitle
*/
export class CardTitle extends React.Component {
  /*constructor( props ){

    }*/
  render() {
    return (
      <h4
        className={`cardTitle dash-below dash-center dash-medium dash-${
          this.props.color
        } uppercase ${this.props.classes}`}
      >
        {this.props.children}
      </h4>
    );
  }
}

/*
    Body Text
*/
export class BodyCopy extends React.Component {
  /*constructor( props ){

    }*/
  render() {
    return (
      <p className={`body-copy font-helvetica ${this.props.classes}`}>
        {this.props.children}
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./src/typography/typography.js